(() => {
  if (window.__StIncInit) return;

  const euro  = c => (Math.max(0,c|0)/100).toFixed(2).replace('.',',')+'\u00a0\u20ac';
  const clamp = (v,thr) => { if(!thr) return 0; let p=(v/thr)*100; if(v>0&&p<1)p=1; return Math.min(100,Math.round(p)); };
  const grad  = (color,pct) => `linear-gradient(to right,${color} 0%,${color} ${pct}%,rgba(60,66,74,0.12) ${pct}%,rgba(60,66,74,0.12) 100%)`;

  const SVG = {
    check:   '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
    truck:   '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>',
    gift:    '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>',
    checkSm: '<svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
    truckSm: '<svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>',
    giftSm:  '<svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>'
  };

  let _product = null;

  function calcQualifying(root, items) {
    const mode      = root.dataset.promoMode || 'tag';
    const tag       = root.dataset.qualifyingTag || '';
    const variantId = parseInt(root.dataset.qualifyingVariantId||'0',10);
    return items.reduce((sum, item) => {
      if (item.properties && item.properties._free_gift === 'promo_gift') return sum;
      let q = false;
      if (mode === 'tag') {
        q = !tag;
        if (!q && item.product_tags) q = item.product_tags.includes(tag);
        if (!q && item.tags) q = item.tags.includes(tag);
      } else if (mode === 'variant') {
        q = variantId > 0 && item.variant_id === variantId;
      }
      return q ? sum + (item.final_line_price || item.original_line_price || 0) : sum;
    }, 0);
  }

  function updateUI(root, cart) {
    const shipThr  = parseInt(root.dataset.shipThreshold||'0',10);
    const giftThr  = parseInt(root.dataset.giftThreshold||'0',10);
    const giftOn   = root.dataset.giftEnabled === 'true';
    const gTitle   = root.dataset.giftTitle || 'Gratisartikel';
    const giftVal  = parseInt(root.dataset.giftValue||'0',10);
    const shipPr   = parseInt(root.dataset.shipPrice||'495',10);
    const shipIsCh = root.dataset.shipIsCh === 'true';
    const shipPrReduced = parseInt(root.dataset.shipPriceReduced||'0',10);
    /* CH: nie "gratis", nur reduzierte Verzollung (23€ -> 17€, Ersparnis = Differenz) */
    const shipSavingCents = shipIsCh ? Math.max(0, shipPr - shipPrReduced) : shipPr;
    const shipGoalLabel   = shipIsCh ? 'bis zur reduzierten Verzollung' : 'bis zum Gratis-Versand';
    const shipDoneLabel   = shipIsCh ? 'Verzollung reduziert' : 'Gratis-Versand';
    const items    = cart.items || [];
    const total    = cart.total_price || 0;
    const qualifying = giftOn ? calcQualifying(root, items) : 0;

    const hasShipGoal = shipThr > 0;
    const hasGiftGoal = giftOn && giftThr > 0;
    const shipOk     = hasShipGoal && total >= shipThr;
    const shipFree   = !hasShipGoal || shipOk; /* Grenze 0 = generell frei (wie Footer) */
    const giftOk     = hasGiftGoal && qualifying >= giftThr;
    const giftInCart = giftOn && items.some(i => i.properties && i.properties._free_gift === 'promo_gift');
    const giftSecured = giftInCart || !hasGiftGoal;

    const elHead  = root.querySelector('#st-headline');
    const elAmt   = root.querySelector('#st-amount');
    const elGoal  = root.querySelector('#st-goal');
    const elFill  = root.querySelector('#st-fill');
    const elThumb = root.querySelector('#st-thumb');
    const elNote  = root.querySelector('#st-note');
    const elCta   = root.querySelector('#st-gift-open');
    const elCtaV  = root.querySelector('#st-cta-value');
    const elDone  = root.querySelector('#st-done-line');
    if (!elFill || !elThumb) return;

    /* Ziele in Schwellen-Reihenfolge; naechstes offenes Ziel bestimmen */
    const goals = [];
    if (hasShipGoal) goals.push({ type:'ship', thr:shipThr, val:total, done:shipOk });
    if (hasGiftGoal) goals.push({ type:'gift', thr:giftThr, val:qualifying, done:giftOk });
    goals.sort((a,b) => a.thr - b.thr);
    const next = goals.find(g => !g.done) || null;
    const allDone = !next && giftSecured;

    const show = (el, on) => { if (el) el.style.display = on ? '' : 'none'; };
    const setThumb = (mode) => {
      elThumb.className = 'st-inc__thumb' + (mode==='ready' ? ' st-inc__thumb--ready' : '') + (mode==='done' ? ' st-inc__thumb--done' : '');
      if (mode==='done') {
        elThumb.innerHTML = '<span class="st-inc__thumb-check">' + SVG.check + '</span>';
      } else {
        elThumb.innerHTML = (mode==='gift' || mode==='ready') ? SVG.gift : SVG.truck;
      }
    };
    const euroS = c => euro(c);

    /* CTA: sichtbar solange Gift verfuegbar & nicht gewaehlt */
    show(elCta, giftOk && !giftInCart);
    if (elCtaV) elCtaV.textContent = giftVal > 0 ? '\u00b7 Wert ' + euroS(giftVal) : '';

    if (allDone) {
      /* Alles erreicht: kompakte Bestaetigung */
      show(elHead, false); show(elNote, false); show(elDone, true);
      elFill.style.width = '100%';
      elFill.className = 'st-inc__fill st-inc__fill--green';
      setThumb(giftInCart ? 'done' : 'done');
      let saving = 0;
      if (giftInCart) saving += giftVal;
      if (hasShipGoal && shipOk) saving += shipSavingCents;
      if (!hasShipGoal) saving += 0; /* generell frei: kein Incentive-Verdienst */
      if (elDone) {
        const parts = [];
        if (giftInCart) parts.push(gTitle);
        if (hasShipGoal && shipOk) parts.push(shipDoneLabel);
        elDone.innerHTML = SVG.check + '\u00a0' + parts.join(' & ') + ' gesichert' + (saving > 0 ? ' \u2013 du sparst ' + euroS(saving) : '');
      }
      return;
    }

    show(elHead, true); show(elDone, false);

    if (next) {
      /* Naechstes Ziel als Headline */
      const rem = Math.max(0, next.thr - next.val);
      if (elAmt)  elAmt.textContent  = 'Noch ' + euroS(rem);
      if (elGoal) elGoal.textContent = next.type === 'ship' ? shipGoalLabel : 'bis zu deinem ' + gTitle;
      if (elHead) elHead.className = 'st-inc__headline';
      elFill.style.width = clamp(next.val, next.thr) + '%';
      elFill.className = 'st-inc__fill';
    } else {
      /* Alle Schwellen erreicht, Gift aber noch nicht gewaehlt */
      if (elAmt)  elAmt.textContent  = 'Geschafft!';
      if (elGoal) elGoal.textContent = 'dein ' + gTitle + ' wartet auf dich';
      if (elHead) elHead.className = 'st-inc__headline st-inc__headline--ok';
      elFill.style.width = '100%';
      elFill.className = 'st-inc__fill st-inc__fill--green';
    }

    /* Thumb: Icon des naechsten offenen Ziels; Gift-Pulse nur wenn Gift die letzte offene Aktion ist */
    if (next) setThumb(next.type === 'ship' ? 'truck' : 'gift');
    else if (giftOk && !giftInCart) setThumb('ready');
    else setThumb('gift');

    /* Kontextzeile */
    if (elNote) {
      let note = '';
      if (giftInCart && next && next.type === 'ship') {
        note = '<strong>\u2713 ' + gTitle + ' gesichert</strong> \u00b7 spar dir noch ' + euroS(shipSavingCents) + (shipIsCh ? ' auf die Verzollung' : ' Versand');
      } else if (giftOk && !giftInCart && next && next.type === 'ship') {
        note = '<strong>\u2713 ' + gTitle + ' verf\u00fcgbar</strong> \u00b7 danach: ' + shipDoneLabel;
      } else if (hasGiftGoal && !giftOk && next && next.type === 'gift') {
        note = giftVal > 0 ? gTitle + ' im Wert von <strong>' + euroS(giftVal) + '</strong>' : '';
        if (hasShipGoal && shipOk) note = '<strong>\u2713 ' + shipDoneLabel + ' gesichert</strong>' + (note ? ' \u00b7 ' + note : '');
        else if (hasShipGoal && !shipOk && shipThr > giftThr) note += (note ? ' \u00b7 ' : '') + 'danach: ' + shipDoneLabel + ' ab ' + euroS(shipThr);
      } else if (hasGiftGoal && !giftOk && next && next.type === 'ship') {
        note = giftVal > 0 ? 'Danach wartet dein ' + gTitle + ' im Wert von <strong>' + euroS(giftVal) + '</strong>' : '';
      } else if (shipOk && hasGiftGoal && !giftOk) {
        note = '<strong>\u2713 ' + shipDoneLabel + ' gesichert</strong>';
      }
      elNote.innerHTML = note;
      show(elNote, !!note);
    }
  }

  let lastFetch = 0;
  function refresh() {
    const now = Date.now();
    if (now - lastFetch < 120) return;
    lastFetch = now;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(r => r.json())
      .then(cart => document.querySelectorAll('#st-incentives').forEach(r => updateUI(r, cart)))
      .catch(() => {});
  }

  /* Global sofort verfügbar machen – BEVOR alles andere */
  window.__StIncRefresh = refresh;
  window.__StIncInit    = true;

  /* MutationObserver – feuert wenn #st-incentives ins DOM kommt */
  const _obs = new MutationObserver(() => {
    if (document.querySelector('#st-incentives')) refresh();
  });
  _obs.observe(document.body, { childList: true, subtree: true });

  refresh();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  setTimeout(refresh, 300);
  setTimeout(refresh, 800);

  ['cart:refresh','cart:updated'].forEach(e => document.addEventListener(e, refresh));
  document.addEventListener('cart:open', () => setTimeout(refresh, 50));
  window.addEventListener('sterntaler-cart-update', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  document.addEventListener('change', e => { if (e.target?.classList?.contains('quantity__input')) setTimeout(refresh, 80); });
  document.addEventListener('click', e => {
    if (e.target.closest('.cart-remove-button,[data-cart-remove],[data-remove],button[name="remove"]')) setTimeout(refresh, 120);
  });
  document.addEventListener('submit', e => {
    const f = e.target; if (!(f instanceof HTMLFormElement)) return;
    const a = f.getAttribute('action') || f.action || '';
    if (a.includes('/cart/add')) { setTimeout(refresh, 250); setTimeout(refresh, 800); }
  });
  try {
    const oF = window.fetch;
    window.fetch = function(input) {
      let url = ''; try { url = (typeof input==='string' ? input : input.url) || ''; } catch(_) {}
      const p = oF.apply(this, arguments);
      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))
        p.finally(() => { setTimeout(refresh, 80); setTimeout(refresh, 400); });
      return p;
    };
  } catch(_) {}
  try {
    const OX = window.XMLHttpRequest;
    function WX() {
      const x = new OX(); let _u = '';
      x.open = (function(o) { return function(m,u) { _u = String(u||''); return o.apply(x,arguments); }; })(x.open);
      x.addEventListener('loadend', () => {
        if (_u.includes('/cart/add') || _u.includes('/cart/change') || _u.includes('/cart/update'))
          { setTimeout(refresh,80); setTimeout(refresh,400); }
      });
      return x;
    }
    window.XMLHttpRequest = WX;
  } catch(_) {}

  /* ── Modal ── */
  async function loadProduct(handle) {
    if (_product) return _product;
    if (!handle) throw new Error('no handle');
    const r = await fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } });
    if (!r.ok) throw new Error('HTTP ' + r.status);
    const p = await r.json();
    p.availableVariants = (p.variants || []).filter(v => !!v.available);
    _product = p; return p;
  }
  const getColors = p => { const c=[]; (p.availableVariants||[]).forEach(v => { if(v.option1&&!c.includes(v.option1)) c.push(v.option1); }); return c; };
  const getSizes  = (p,col) => { const s=[]; (p.availableVariants||[]).forEach(v => { if(v.option1===col&&v.option2&&!s.includes(v.option2)) s.push(v.option2); }); return s; };
  const getImg    = v => { if(!v) return ''; if(v.featured_image&&typeof v.featured_image==='object') return v.featured_image.src||''; if(typeof v.featured_image==='string') return v.featured_image; return v.featured_media?.preview_image?.src||''; };
  const selColor = () => document.querySelector('.pg-color-card.is-active')?.dataset.color || '';
  const selSize  = () => document.querySelector('.pg-size-pill.is-active')?.dataset.size || '';
  const findVar  = () => {
    if (!_product) return null;
    const c = selColor(), s = selSize();
    return (_product.availableVariants||[]).find(v => v.option1===c && v.option2===s) || null;
  };

  function updateHero(color) {
    const hero = document.querySelector('#pg-modal-hero');
    const placeholder = document.querySelector('#pg-modal-hero-placeholder');
    if (!hero || !_product) return;
    const ref = (_product.availableVariants||[]).find(v => v.option1===color) || null;
    const src = getImg(ref);
    let existing = hero.querySelector('.pg-modal__hero-img');
    if (src) {
      if (existing) { existing.src = src; }
      else {
        const img = document.createElement('img');
        img.className = 'pg-modal__hero-img';
        img.src = src; img.alt = color; img.loading = 'lazy';
        hero.insertBefore(img, hero.firstChild);
      }
      if (placeholder) placeholder.style.display = 'none';
    } else {
      if (existing) existing.remove();
      if (placeholder) placeholder.style.display = '';
    }
  }

  function updateProductValue() {
    const el = document.querySelector('#pg-modal-value');
    if (!el || !_product) return;
    const prices = (_product.variants||[]).map(v => v.compare_at_price || v.price).filter(Boolean);
    if (!prices.length) { el.textContent = ''; return; }
    const maxPrice = Math.max(...prices);
    if (maxPrice > 0) {
      const fmt = (maxPrice/100).toFixed(2).replace('.',',') + ' €';
      el.innerHTML = '<span class="pg-free">0,00\u00a0\u20ac</span><span class="pg-was">' + fmt + '</span>';
    }
  }

  function renderSizes(color) {
    const wrap = document.querySelector('#pg-size-options');
    if (!wrap || !_product) return;
    const prevSize = selSize();
    wrap.innerHTML = '';
    const availSizes = getSizes(_product, color);
    const allSizes = [];
    (_product.variants||[]).forEach(v => { if(v.option1===color && v.option2 && !allSizes.includes(v.option2)) allSizes.push(v.option2); });
    allSizes.forEach((size, i) => {
      const avail = availSizes.includes(size);
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.dataset.size = size;
      btn.className = 'pg-size-pill' + (!avail ? ' is-unavailable' : '');
      if (avail && (prevSize === size || (!prevSize && i === 0))) btn.classList.add('is-active');
      btn.textContent = size;
      if (!avail) btn.disabled = true;
      wrap.appendChild(btn);
    });
    if (!wrap.querySelector('.pg-size-pill.is-active')) {
      const first = wrap.querySelector('.pg-size-pill:not(.is-unavailable)');
      if (first) first.classList.add('is-active');
    }
  }

  function updateModalStatus() {
    const st  = document.querySelector('#pg-variant-status');
    const btn = document.querySelector('#pg-add-btn');
    if (!st || !btn) return;
    if (!_product?.availableVariants?.length) { st.textContent='Aktuell nicht verfügbar.'; btn.disabled=true; return; }
    const color = selColor();
    renderSizes(color);
    const nameEl = document.querySelector('#pg-color-name');
    if (nameEl) nameEl.textContent = color ? ' \u00b7 ' + color : '';
    const v = findVar();
    if (!v) { st.className='pg-variant-status'; st.textContent='Bitte wähle Farbe und Größe.'; btn.disabled=true; return; }
    st.className = 'pg-variant-status';
    st.innerHTML = '<strong>' + [v.option1, v.option2].filter(Boolean).join(' \u00b7 ') + '</strong> ausgewählt';
    btn.disabled = false;
  }

  function renderColors() {
    const wrap = document.querySelector('#pg-color-options'); if(!wrap||!_product) return;
    wrap.innerHTML = '';
    getColors(_product).forEach((color, i) => {
      const ref = (_product.availableVariants||[]).find(v=>v.option1===color) || null;
      const btn = document.createElement('button');
      btn.type='button'; btn.className='pg-color-card'+(i===0?' is-active':''); btn.dataset.color=color;
      const src = getImg(ref);
      if (src) { const img=document.createElement('img'); img.className='pg-color-card__image'; img.src=src; img.alt=color; img.loading='lazy'; btn.appendChild(img); }
      else { const ph=document.createElement('div'); ph.className='pg-color-card__placeholder'; ph.textContent=color.charAt(0).toUpperCase(); btn.appendChild(ph); }
      btn.setAttribute('aria-label', color); btn.title = color;
      wrap.appendChild(btn);
    });
    const firstColor = getColors(_product)[0] || '';
    updateHero(firstColor);
    updateProductValue();
    updateModalStatus();
  }
  async function openModal() {
    const modal = document.querySelector('#pg-modal');
    const st    = document.querySelector('#pg-variant-status');
    const btn   = document.querySelector('#pg-add-btn');
    if (!modal) return;
    modal.hidden = false; document.body.classList.add('pg-modal-open');
    if (st) st.textContent='Lade Produkt…'; if (btn) btn.disabled=true;
    try {
      const handle = document.querySelector('#st-incentives')?.dataset.giftHandle || '';
      await loadProduct(handle);
      if (!_product?.availableVariants?.length) { if(st) st.textContent='Aktuell nicht verfügbar.'; return; }
      renderColors();
      /* Gruppen mit nur einer Option ausblenden – weniger Klick-Rauschen */
      const colorGroup = document.querySelector('#pg-color-options')?.closest('.pg-option-group');
      if (colorGroup) colorGroup.style.display = getColors(_product).length > 1 ? '' : 'none';
      const sizeGroup = document.querySelector('#pg-size-options')?.closest('.pg-option-group');
      if (sizeGroup) {
        const sizeCount = document.querySelectorAll('#pg-size-options .pg-size-pill').length;
        sizeGroup.style.display = sizeCount > 1 ? '' : 'none';
      }
      try { modal.querySelector('.pg-modal__close')?.focus({ preventScroll: true }); } catch(_) {}
    } catch(e) { console.warn('[StInc]', e); if(st) st.textContent='Produkt konnte nicht geladen werden.'; }
  }
  function closeModal() {
    const m = document.querySelector('#pg-modal'); if(!m) return;
    m.hidden=true; document.body.classList.remove('pg-modal-open');
  }

  document.addEventListener('click', async e => {
    if (e.target.closest('#st-gift-open'))        { e.preventDefault(); await openModal(); return; }
    if (e.target.closest('.pg-modal__close') ||
        e.target.closest('.pg-modal__backdrop'))  { e.preventDefault(); closeModal(); return; }
    const cb = e.target.closest('.pg-color-card');
    if (cb) {
      e.preventDefault();
      document.querySelectorAll('.pg-color-card').forEach(b=>b.classList.remove('is-active'));
      cb.classList.add('is-active');
      updateHero(cb.dataset.color);
      updateModalStatus();
      return;
    }
    const sp = e.target.closest('.pg-size-pill');
    if (sp && !sp.disabled) {
      e.preventDefault();
      document.querySelectorAll('.pg-size-pill').forEach(b=>b.classList.remove('is-active'));
      sp.classList.add('is-active');
      updateModalStatus();
      return;
    }
    if (e.target.closest('#pg-add-btn')) {
      const st  = document.querySelector('#pg-variant-status');
      const btn = document.querySelector('#pg-add-btn');
      const v   = findVar(); if (!v) { updateModalStatus(); return; }
      btn.disabled = true;
      const btnLabel = btn.querySelector('span') || btn;
      const prevLabel = btnLabel.textContent;
      btnLabel.textContent = 'Wird hinzugef\u00fcgt\u2026';
      try {
        const res = await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({
          items:[{id:v.id,quantity:1,properties:{_free_gift:'promo_gift'}}],
          sections:'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        }) });
        if (!res.ok) throw new Error('Cart add failed');
        const data = await res.json();
        const drawerEl = document.querySelector('cart-drawer');
        if (data.sections && drawerEl && typeof drawerEl.renderContents === 'function') {
          /* Nahtlos: Drawer per Section Rendering aktualisieren, kein Reload */
          closeModal();
          try { drawerEl.renderContents({ sections: data.sections, id: v.id }); } catch(_) { drawerEl.classList.add('active'); }
          setTimeout(() => { try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch(_) {} }, 100);
        } else {
          /* Fallback: wie bisher Reload + Drawer wieder oeffnen */
          try { sessionStorage.setItem('reopenCartDrawer','1'); } catch(_) {}
          window.location.reload();
        }
      } catch(e) { console.warn('[StInc]',e); btn.disabled=false; btnLabel.textContent=prevLabel; if(st) st.textContent='Konnte nicht hinzugef\u00fcgt werden.'; }
    }
  });
  // size pills handled via click above
  document.addEventListener('keydown', e => { if (e.key==='Escape') closeModal(); });

  function openDrawer() {
    const d = document.querySelector('cart-drawer');
    if (d && typeof d.open==='function') { try { d.open(); return; } catch(_) {} }
    try { document.dispatchEvent(new CustomEvent('cart:open')); } catch(_) {}
    for (const s of ['#cart-icon-bubble a','#cart-icon-bubble button','button[aria-controls="CartDrawer"]','.header__icon--cart']) {
      const el = document.querySelector(s); if (el) { el.click(); return; }
    }
  }
  try {
    if (sessionStorage.getItem('reopenCartDrawer')==='1') {
      sessionStorage.removeItem('reopenCartDrawer');
      if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', openDrawer);
      else openDrawer();
    }
  } catch(_) {}
})();